module.exports = __webpack_public_path__ + "img/icon-take-picture.280ba4f4.svg";